module.exports = __webpack_public_path__ + "videos/legacy_lg.f8063e9.mp4";